import { Box } from '@mui/system';
import React, { useState, useEffect } from 'react';
import useFetch from '../../utils/useFetch';
import BaseURL from '../../utils/base-uri.json';

export default function SectionHeaderFooter({ title,content }) {
    //const { data: resp, loading, error, } = useFetch("http://fvapi.firstverify.com/api/Prequalification/GetHeaderFooter?sectionId=" + Secid)
    // const [userResponse, setUserResponse] = useState([]);
    // useEffect(() => {
    //     if (resp?.data) {
    //         setUserResponse(resp.data)
    //         console.log(resp.data)
    //     }
    // }, [resp]);
    return (
        <Box sx={{ backgroundColor: "#fff" }}>
         
             
                    <Box sx={{ paddingLeft: "27px", paddingRight: "20px" }}>
                        {title}
                    </Box>

                    <br></br>
                    <Box sx={{ paddingLeft: "27px", paddingRight: "20px" }}>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                    </Box>
             

        </Box>
    )
}
